// this hashing algorithm is as found in some version of Google Analytics
/* jshint ignore:start */
var sha = require('./sha1');
function hash(d) {
    var a = 1, c = 0, h, o;
    if (d) {
        a = 0;
        for (h = d["length"] - 1; h >= 0; h--) {
            o = d.charCodeAt(h);
            a = (a << 6 & 268435455) + o + (o << 14);
            c = a & 266338304;
            a = c != 0 ? a ^ c >> 21 : a
        }
    }
    return a
};

module.exports = {
    domainHash : hash,
    sessionHash : sha,
    userHash : sha
}; 

/* jshint ignore:end */



//////////////////
// WEBPACK FOOTER
// ./src/domain_hash.js
// module id = 11
// module chunks = 0 1 2